import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'
import { cn } from '#app/utils/misc.tsx'
import { type Theme } from '#app/utils/theme.server'

const BrandVariants = cva('object-fit', {
	variants: {
		variant: {
			logo: 'w-[132.2px] shrink-0',
			icon: 'w-[31.2px] shrink-0',
		},
	},
	defaultVariants: {
		variant: 'logo',
	},
})

export interface BrandProps
	extends React.ImgHTMLAttributes<HTMLImageElement>,
		VariantProps<typeof BrandVariants> {
	asChild?: boolean
	mTheme?: Theme | ''
}

const Brand = React.forwardRef<HTMLImageElement, BrandProps>(
	({ className, variant, mTheme = '', asChild = false, ...props }, ref) => {
		const Comp = asChild ? Slot : 'img'
		let theme = 'light'
		theme = mTheme === '' ? theme : mTheme

		return (
			<Comp
				className={cn(BrandVariants({ variant, className }))}
				src={
					variant === 'logo'
						? theme === 'light'
							? '/img/brand/logo.svg'
							: '/img/brand/logo-dark.svg'
						: theme === 'light'
							? '/img/brand/icon.svg'
							: '/img/brand/icon-dark.svg'
				}
				ref={ref}
				{...props}
			/>
		)
	},
)

Brand.displayName = 'Brand'

export { Brand, BrandVariants }
